import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import {
    Card,
    CardBody,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { dateFormat } from "pages/Common"
import LineApexChart from "./chartapex"
import Select from "react-select";

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "35px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

let model1 = false
function CustomerAttendChartReport() {
    document.title = `Customer Attend Report | Raja Rani Couture`
    let { pathname } = useLocation()
    const flatpickrRef = useRef(null);
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    // useStates
    const [screenLoad, setScreenLoad] = useState(false)
    const [userControls, setUserControls] = useState([])
    const [userFilter, setUserFilter] = useState({
        label: 'Select user',
        value: 0,
    })
    const [filterType, setFilterType] = useState("MONTH")
    const [months, setMonths] = useState([])
    const [selectedMonth, setSelectedMonth] = useState(
        {
            label: monthNames[new Date().getMonth()],
            value: monthNames[new Date().getMonth()],
        }
    );
    const [years, setYears] = useState([])
    const [selectedYear, setSelectedYear] = useState();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [chartData, setChartData] = useState([])

    useEffect(() => {
        const monthOptions = monthNames.map((month) => ({
            label: month,
            value: month
        }));
        setMonths(monthOptions);

        // Set default selected month
        const currentMonth = monthOptions[new Date().getMonth()];
        setSelectedMonth(currentMonth);

        const currentYear = new Date().getFullYear();

        // Generate dynamic year options: current year and past 2 years
        const yearOptions = [0, 1, 2].map((i) => {
            const year = currentYear - i;
            return {
                label: year.toString(),
                value: year.toString()
            };
        });

        setYears(yearOptions);
        setSelectedYear(yearOptions[0]);

    }, []);

    function getMonthDateRange(monthName, year) {
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
        const fromDate = new Date(year, monthIndex, 1);
        const toDate = new Date(year, monthIndex + 1, 0);
        return { fromDate, toDate };
    }

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                options.unshift({
                    label: "Select user",
                    value: 0,
                }
                );
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }, [])

    // task-title list api
    const unbillRentChatReportApi = (fromDate, toDate) => {
        setScreenLoad(true)
        postApi("CustomerAttend/report", {
            UserId: parseInt(userFilter.value),
            filterType: filterType,
            FromDate: fromDate,
            Todate: toDate,
        }).then(({ data, status }) => {
            if (status === 200) {
                setChartData(data)
                setScreenLoad(false)
            } else {
                setScreenLoad(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    // task-report api useEffect
    useEffect(() => {
        if (filterType === "MONTH" && selectedMonth && selectedYear) {
            const { fromDate, toDate } = getMonthDateRange(selectedMonth?.value, selectedYear?.value);
            unbillRentChatReportApi(dateFormat(fromDate, "yyyy-MM-dd"), dateFormat(toDate, "yyyy-MM-dd"))
        } else if (filterType === "YEAR" && selectedYear) {
            setFromDate()
            setToDate()
            unbillRentChatReportApi(`${selectedYear?.value}-01-01`, `${selectedYear?.value}-12-31`)
        } else {
            setFromDate(null)
            setToDate(null)
            unbillRentChatReportApi(null, null)
        }
    }, [userFilter, filterType, selectedMonth, selectedYear])

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md="2" className="table-header" >
                                <FormGroup className="mb-2">
                                    <Select
                                        unstyled
                                        styles={colourStyles}
                                        value={userFilter}
                                        onChange={(e) => {
                                            setUserFilter(e)
                                        }}
                                        options={userControls}
                                        className="select2-selection"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <div style={{ marginTop: "10px" }}>
                                    <div className=" d-flex gap-2">
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value="MONTH"
                                                id="Month"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={filterType == "MONTH"}
                                                onClick={() => { setFilterType("MONTH") }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13 me-2" htmlFor="Month">
                                            Month
                                        </Label>
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value="YEAR"
                                                id="Year"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={filterType == "YEAR"}
                                                onClick={() => { setFilterType('YEAR') }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13 me-2" htmlFor="Year">
                                            Year
                                        </Label>
                                        <FormGroup>
                                            <Input
                                                type="radio"
                                                value='ALL'
                                                id="All"
                                                // name="gender"
                                                className="form-check-input"
                                                checked={filterType == "ALL"}
                                                onClick={() => { setFilterType('ALL') }}
                                            />
                                        </FormGroup>
                                        <Label className="form-check-label font-size-13 me-3" htmlFor="All">
                                            All
                                        </Label>
                                    </div>
                                </div>
                            </Col>
                            <Col md="2" className="table-header" >
                                <FormGroup className="mb-2">
                                    <Select
                                        unstyled
                                        isDisabled={filterType == "ALL"}
                                        styles={colourStyles}
                                        value={selectedYear}
                                        onChange={(e) => {
                                            setSelectedYear(e)
                                        }}
                                        options={years}
                                        className="select2-selection"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="2" className="table-header" >
                                <FormGroup className="mb-2">
                                    <Select
                                        unstyled
                                        isDisabled={filterType == "YEAR" || filterType == "ALL"}
                                        styles={colourStyles}
                                        value={selectedMonth}
                                        onChange={(e) => {
                                            setSelectedMonth(e)
                                        }}
                                        options={months}
                                        className="select2-selection"
                                    />
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col xl={12} className="mt-2">
                                <Card>
                                    <CardBody>
                                        <LineApexChart dataColors='["--bs-success","--bs-danger"]' chartData={chartData} filterType={filterType == "MONTH" ? 'Date' : filterType == "YEAR" ? 'Month' : "Year"} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </div >
    )
}
CustomerAttendChartReport.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default CustomerAttendChartReport
